<label>{{ inputLabel }}</label>
<ul class="scrollable-list" [attr.data-qa-id]="'scrollable-list'">
  @for (item of list; track item; let i = $index) {
    <li
      (click)="listItemClicked(i)"
      class="scrollable-list__item color-grey"
      [ngClass]="{
        'scrollable-list__item--selected': i === selectedItem,
        'scrollable-list__item--no-scroll': list.length < 5
      }"
    >
      <span class="truncate">{{ item }}</span>
    </li>
  }
</ul>
